import api from './api';

export const surgeryService = {
    // Surgery Requests
    createRequest: async (data) => {
        try {
            const response = await api.post('/surgery/request', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to create surgery request');
        }
    },

    getRequests: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/surgery/requests?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch surgery requests');
        }
    },

    getRequest: async (requestId) => {
        try {
            const response = await api.get(`/surgery/request/${requestId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch surgery request');
        }
    },

    // Approvals
    approveRequest: async (requestId, data) => {
        try {
            const response = await api.post(`/surgery/${requestId}/approve`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to approve request');
        }
    },

    // Scheduling
    scheduleSurgery: async (requestId, data) => {
        try {
            const response = await api.post(`/surgery/${requestId}/schedule`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to schedule surgery');
        }
    },

    getCalendar: async (startDate, endDate) => {
        try {
            const response = await api.get(`/surgery/calendar?startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch calendar');
        }
    },

    // Surgery Operations
    startSurgery: async (surgeryId) => {
        try {
            const response = await api.put(`/surgery/${surgeryId}/start`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to start surgery');
        }
    },

    completeSurgery: async (surgeryId, data) => {
        try {
            const response = await api.put(`/surgery/${surgeryId}/complete`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to complete surgery');
        }
    },

    getSurgery: async (surgeryId) => {
        try {
            const response = await api.get(`/surgery/${surgeryId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch surgery');
        }
    }
};
